import React from 'react'
import { ChatMessage } from './ChatMessage.tsx'
import data from "../data.json"
import { TMessage } from '../types/TMessage.tsx'

export function ChatInterface() {
  return (
    <div className="flex flex-col h-dvh bg-[#e5ddd5]">
      <div className="bg-[#075e54] text-white p-4">
        <h1 className="text-lg font-semibold">Chat mit Opa</h1>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        <div className="max-w-2xl mx-auto">
          {data.map((message: TMessage, index) => (
            <ChatMessage
              key={index}
              {...message}
            />
          ))}
        </div>
        <div className='w-full h-10 flex items-center justify-center'>
        <span className='text-gray-400'>
          Ende des Chat-Verlaufs
          </span>
        </div>
      </div>
    </div>
  )
}

